import React from 'react';
import PropTypes from 'prop-types';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import DialogActions from '@material-ui/core/DialogActions';
import DialogTitle from '@material-ui/core/DialogTitle';
import CloseIcon from '@material-ui/icons/Close';
import TextField from '@material-ui/core/TextField';
import CircularProgress from '@material-ui/core/CircularProgress';
import styles from './UploadFilesClinicModal.scss';

export const ADD_NEW_COLLECTION_KEY = 'ADD_NEW_COLLECTION_KEY';

export const UploadFilesClinicModal = ({
  isOpen,
  onSave,
  onCancel,
  onClose,
  onInputFileChange,
  selectedFile,
  categoryInput,
  setCategoryInput,
  titleInput,
  setTitleInput,
  titleInputError,
  selectedCategoryError,
  isLoadingUploadFile,
  isModalEditMode,
  resourcesNames,
  selectedCategory,
  setSelectedCategory,
  setTitleInputError,
  setSelectedCategoryError,
}) => {
  return (
    <Dialog
      open={isOpen}
      onClose={onClose}
      disableBackdropClick
      disableEscapeKeyDown
      classes={{ paper: styles.dialog_root }}
    >
      <CloseIcon
        style={{
          cursor: isLoadingUploadFile ? 'auto' : 'pointer',
          position: 'absolute',
          right: 10,
          top: 10,
          fontSize: 14,
        }}
        onClick={() => {
          if (!isLoadingUploadFile) {
            onCancel();
          }
        }}
      />
      <DialogTitle>
        <span className={styles.dialog_header}>
          {isModalEditMode ? 'Edit Resource' : 'Create New Resource'}
        </span>
      </DialogTitle>
      <div className={styles.dialog_content}>
        <div className={styles.input_item_title}>
          * Select File (Video/mp4 or PDF)
        </div>
        <TextField
          variant="outlined"
          value={`Choose File:  ${
            selectedFile ? selectedFile.name : 'No file chosen'
          }`}
          onClick={e => {
            e.preventDefault();
            e.stopPropagation();
            document.getElementById('file-input').click();
          }}
          InputProps={{
            classes: {
              root: styles.root_input,
              input: styles.text_input,
            },
          }}
          style={{ width: '100%', caretColor: 'transparent' }}
          disabled={isLoadingUploadFile}
        />
        <input
          accept="video/mp4,application/pdf"
          hidden
          id="file-input"
          type="file"
          onChange={onInputFileChange}
          style={{ display: 'none' }}
        />
        <div className={styles.upload_btn}>
          <Button
            onClick={e => {
              e.preventDefault();
              e.stopPropagation();
              document.getElementById('file-input').click();
            }}
            color="primary"
            variant="contained"
            disabled={isLoadingUploadFile}
          >
            Open
          </Button>
        </div>
        <div className={styles.input_item_title}>* Resource Title</div>
        <div style={{ marginBottom: 10 }}>
          This is how the resource title will appear on the app
        </div>
        <TextField
          variant="outlined"
          InputProps={{
            classes: {
              root: styles.root_input,
              input: styles.text_input,
            },
          }}
          id="file-name"
          style={{ width: '100%' }}
          onChange={e => {
            if (e.target.value.trim()) {
              setTitleInputError('');
            }
            setTitleInput(e.target.value);
          }}
          value={titleInput}
          disabled={isLoadingUploadFile}
        />
        {titleInputError ? (
          <div
            className={styles.input_item_title}
            style={{ color: '#EF4444', marginTop: 5, fontSize: 12 }}
          >
            Title is required
          </div>
        ) : null}
        <div className={styles.input_item_title} style={{ marginTop: 30 }}>
          * Collection
        </div>
        <div style={{ display: 'flex', position: 'relative' }}>
          <Select
            onChange={e => {
              setSelectedCategoryError(false);
              setSelectedCategory(e.target.value);
            }}
            variant="outlined"
            value={selectedCategory}
            style={{ width: '100%', fontSize: 14 }}
            disabled={isLoadingUploadFile}
          >
            {resourcesNames.map(name => (
              <MenuItem value={name} style={{ fontSize: 13 }}>
                {name}
              </MenuItem>
            ))}
            <MenuItem
              value={ADD_NEW_COLLECTION_KEY}
              style={{ fontSize: 13, color: 'blue' }}
            >
              Create new collection
            </MenuItem>
          </Select>
        </div>
        {selectedCategory === ADD_NEW_COLLECTION_KEY ? (
          <div>
            <div className={styles.input_item_title}>* New collection:</div>
            <TextField
              variant="outlined"
              InputProps={{
                classes: {
                  root: styles.root_input,
                  input: styles.text_input,
                },
              }}
              style={{ width: '100%', marginRight: 10 }}
              placeholder="Type to add a collection"
              onChange={e => {
                if (e.target.value.trim()) {
                  setSelectedCategoryError(false);
                }
                setCategoryInput(e.target.value);
              }}
              value={categoryInput}
              disabled={isLoadingUploadFile}
            />
          </div>
        ) : null}

        {selectedCategoryError ? (
          <div
            className={styles.input_item_title}
            style={{ color: '#EF4444', marginTop: 5, fontSize: 12 }}
          >
            Collection is required
          </div>
        ) : null}
      </div>

      <DialogActions style={{ marginRight: 20, marginTop: 80 }}>
        <Button
          onClick={onCancel}
          variant="text"
          color="default"
          disabled={isLoadingUploadFile}
        >
          <span className={styles.button}>Cancel</span>
        </Button>
        <Button
          onClick={onSave}
          color="primary"
          variant="contained"
          disabled={(!selectedFile && !isModalEditMode) || isLoadingUploadFile}
        >
          {isLoadingUploadFile ? (
            <CircularProgress style={{ width: 20, height: 20 }} />
          ) : (
            <span className={styles.button}>
              {isModalEditMode ? 'Save change' : 'Create'}
            </span>
          )}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

UploadFilesClinicModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onSave: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  onInputFileChange: PropTypes.func.isRequired,
  selectedFile: PropTypes.object,
  categoryInput: PropTypes.string,
  setCategoryInput: PropTypes.func,
  titleInput: PropTypes.string,
  setTitleInput: PropTypes.func,
  titleInputError: PropTypes.bool,
  selectedCategoryError: PropTypes.bool,
  isLoadingUploadFile: PropTypes.bool,
  isModalEditMode: PropTypes.string,
  resourcesNames: PropTypes.array,
  selectedCategory: PropTypes.string,
  setSelectedCategory: PropTypes.func,
  setTitleInputError: PropTypes.func,
  setSelectedCategoryError: PropTypes.func,
};
